import { render, staticRenderFns } from "./PPLabelCurrentTime.vue?vue&type=template&id=99eff4dc&"
import script from "./PPLabelCurrentTime.vue?vue&type=script&lang=js&"
export * from "./PPLabelCurrentTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../playmaker_app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports